//import node_modules
import React from "react";
import { NextPage } from "next";
import { Container, Row } from "react-bootstrap";
import { cx, css } from "@adjust/libs/emotion";

//import pages
import { PageProps } from "./types";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//components
import PageHeaderComponent from "src/components/PageHeaderComponent";

//locals
import MetaComponent from "./components/MetaDataComponent";
import MentionComponent from "./components/MentionComponent";

const subheaderCSS = css({
  textAlign: "center",
  fontSize: "1.2em",
  margin: "0.75rem auto 0",
  maxWidth: 760,
  lineHeight: 1.7,
  fontFamily: "DM Sans, sans-serif",
});

const PressPage: NextPage<PageProps> = ({ mentions }) => {
  return (
    <SiteLayout>
      <MetaComponent />
      <Container className="my-5">
        <PageHeaderComponent type="h1" className="text-center">
          Mentions in the Press
        </PageHeaderComponent>
        <div className={subheaderCSS}>
          Stacy Gray, owner of Adjust to the Good Life Travel, has been featured as a travel expert on Raleigh news stations, including ABC11 and CBS17, where she shared insights
          on travel trends, the importance of travel insurance, and practical advice for travelers.
        </div>
        <Row className="justify-content-center mt-4">
          {mentions.map((mention) => (
            <MentionComponent key={mention.id} mention={mention} />
          ))}
        </Row>
      </Container>
    </SiteLayout>
  );
};

export default PressPage;
